// Restored from production OTA 2026-08-21 (module 1429).
import {
  FETCH_SETTINGS,
  FETCH_SETTINGS_SUCCESS,
  FETCH_SETTINGS_FAILED,
  EDIT_SETTINGS,
  CLEAR_SETTINGS_ERROR
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { onValue, set } from "firebase/database";

export const fetchSettings = () => (dispatch) => {
  const { settingsRef } = firebase;
  console.log('[fetchSettings] called, settingsRef:', settingsRef ? 'present' : 'MISSING', 'firebase keys:', Object.keys(firebase));

  dispatch({
    type: FETCH_SETTINGS,
    payload: null
  });
  onValue(
    settingsRef,
    (snapshot) => {
      console.log('[fetchSettings] onValue fired, has data:', !!snapshot.val());
      if (snapshot.val()) {
        dispatch({
          type: FETCH_SETTINGS_SUCCESS,
          payload: snapshot.val()
        });
      } else {
        dispatch({
          type: FETCH_SETTINGS_FAILED,
          payload: "Unable to fetch database and settings."
        });
      }
    },
    (error) => {
      // Without this a permission or network error left the app waiting on
      // settings forever with nothing in the log.
      console.log('[fetchSettings] onValue ERROR:', error && error.code, error && error.message);
      dispatch({
        type: FETCH_SETTINGS_FAILED,
        payload: (error && error.message) || 'Failed to fetch settings'
      });
    }
  );
};

export const editSettings = (settings) => (dispatch) => {
  const { settingsRef } = firebase;
  dispatch({
    type: EDIT_SETTINGS,
    payload: settings
  });
  set(settingsRef, settings);
  alert(store.getState().languagedata.defaultLanguage.updated);
};

export const clearSettingsViewError = () => (dispatch) => {
  dispatch({
    type: CLEAR_SETTINGS_ERROR,
    payload: null
  });
};
